import React from 'react';
import { NavLink } from 'react-router-dom';

const NAV = [
  {
    section: 'DASHBOARD',
    items: [
      { to: '/admin/tenants/dashboard/logins', label: 'login_dashboard', tag: '00' },
    ],
  },
  {
    section: 'TENANTS',
    items: [
      { to: '/admin/tenants', label: 'tenant_list', tag: '01', end: true },
      { to: '/admin/tenants/new', label: 'onboard_wizard', tag: '02' },
    ],
  },
  {
    // These operate on a single tenant. Coming from the sidebar (no
    // clientCode picked yet), each page shows a lookup box first; coming
    // from Tenant Detail's quick-links they open pre-loaded.
    section: 'Modules & Forms',
    items: [
      // { to: '/admin/tenants/tools/admin-user', label: 'admin_credentials', tag: '03' },
      { to: '/admin/tenants/tools/permissions', label: 'permissions', tag: '04' },
      // { to: '/admin/tenants/tools/organization', label: 'organization_profile', tag: '05' },
      // { to: '/admin/tenants/tools/seed', label: 'forms_and_modules', tag: '06' },
      { to: '/admin/tenants/tools/modules', label: 'module_management', tag: '07' },
      { to: '/admin/tenants/tools/forms', label: 'form_management', tag: '08' },
    ],
  },
  {
    section: 'MONITORING',
    items: [
      { to: '/admin/tenants/monitoring/db-sizes', label: 'db_sizes', tag: '09' },
      { to: '/admin/tenants/monitoring/all-databases', label: 'all_databases', tag: '10' },
    ],
  },
  {
    section: 'LOGS',
    items: [
      { to: '/admin/tenants/logs/login-history', label: 'login_history', tag: '11' },
      { to: '/admin/tenants/logs/audit', label: 'audit_log', tag: '12' },
      { to: '/admin/tenants/logs/exceptions', label: 'exception_log', tag: '13' },
    ],
  },
];

// Dim, muted color for section headers so they read as labels, not nav
// items. Uses the same --text-dim token already used elsewhere (e.g. the
// "← clientCode" breadcrumb links). If root-sidebar__section already sets
// a color in your stylesheet, prefer changing it there instead and drop
// this inline style — it's here so the change is visible without touching
// CSS you haven't shared.
const sectionStyle = {
  color: 'var(--text-dim)',
  opacity: 0.7,
  letterSpacing: '0.08em',
};

export default function Sidebar() {
  return (
    <aside className="root-sidebar">
      <div className="root-sidebar__brand">
        <div className="root-sidebar__brand-line">waralsadmin@root:~$</div>
        <div className="root-sidebar__brand-title">
          TENANT_CTRL<span className="cursor" />
        </div>
      </div>

      {NAV.map((group) => (
        <div key={group.section}>
          <div className="root-sidebar__section" style={sectionStyle}>{group.section}</div>
          {group.items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `root-nav-item${isActive ? ' active' : ''}`}
            >
              <span>{item.label}</span>
              <span className="root-nav-item__tag" style={{ marginLeft: 'auto' }}>
                {item.tag}
              </span>
            </NavLink>
          ))}
        </div>
      ))}
    </aside>
  );
}